module.exports = __webpack_public_path__ + "img/haijunlan.c20f25bd.png";